import {useGetAnalysisDetail} from '@domain/rcfa'
import {Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {useUrlParam} from '../../../hooks/useUrlParam'
import {FEATURE_NAMESPACE} from '../../../localization'
import {ModalCircularProgress} from '../../common'
import {useNodeDetail} from '../hooks'

import {EditNode} from './EditNode'
import {EditRootNode} from './EditRootNode'

export const EditNodeForm = ({
  nodeId,
  closeForm,
  DragHandle
}: {
  nodeId: number
  closeForm: () => void
  DragHandle: JSX.Element
}) => {
  const analysisId = useUrlParam('analysisId')
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const isMainNode = nodeId === 0
  const {data: nodeDetail, isPending: nodeDetailLoading} = useNodeDetail(nodeId.toString())
  const {data: analysisData, isPending: analysisDataLoading} = useGetAnalysisDetail(analysisId, {
    enabled: isMainNode
  })

  const canRenderRootEdit = isMainNode && nodeDetail && analysisData

  return (
    <Stack
      sx={(theme) => ({
        maxHeight: '55vh',
        overflowY: 'auto',
        background: theme.palette.background.paper
      })}
      spacing={3}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        paddingRight={2}
      >
        <Typography
          variant="h2"
          sx={{
            wordWrap: 'break-word',
            display: 'flex',
            gap: 1,
            alignItems: 'flex-start'
          }}
        >
          {DragHandle}
          {t('label.editNode')}
        </Typography>
      </Stack>
      {(nodeDetailLoading || (isMainNode && analysisDataLoading)) && <ModalCircularProgress />}
      {canRenderRootEdit && (
        <EditRootNode node={nodeDetail} analysisData={analysisData} closeForm={closeForm} />
      )}
      {!isMainNode && nodeDetail && <EditNode node={nodeDetail} closeForm={closeForm} />}
    </Stack>
  )
}
